import i18n from "@/libs/i18n";
export default [
  {
    get header() {
      return i18n.t("emergency.nursing");
    },
    role: "Emergency",
  },
  {
    get title() {
      return i18n.t("emergency.nursing-dashboard");
    },
    route: "emergency",
    icon: "XOctagonIcon",
    permission: "get-emergency",
    role: "Emergency",
  },
  //   {
  //     title: 'Private Announcement',
  //     route: 'Emergancy-Announcement',
  //     icon: 'InfoIcon',
  //     permission: 'show-emergency',
  //     role: 'Emergency',
  //   },
  {
    get title() {
      return i18n.t("emergency.patient-drug-table");
    },
    route: "patient-drug-table",
    icon: "UsersIcon",
    permission: "get-emergency",
    role: "Emergency",
  },
  {
    get title() {
      return i18n.t("emergency.emergency-services");
    },
    route: "emergency-services",
    icon: "SettingsIcon",
    permission: "get-emergency",
    role: "Emergency",
  },
];
